<template>
  <div class="login-container" v-loading="loginLoading">
    <!-- Logo -->
    <div class="logo">
      <logoIcon width="50" height="50" fill="#2f70ff" />
      <span>{{ computedSystemName }}</span>
    </div>

    <!-- 登录方式切换 -->
    <div class="login-type">
      <el-radio-group v-model="loginMethod" @change="changeLoginMethod">
        <el-radio-button style="margin-right: 25px" label="password">密码登录</el-radio-button>
        <el-radio-button label="code">验证码登录</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 地区提示 -->
<!--    <div class="region-tip" v-if="loginMethod === 'code'">您所在地区仅支持手机登录</div>-->
<!--    <div style="height: 22px" v-else></div>-->

    <!-- 登录表单 -->
    <el-form
      class="login-form"
      :model="loginForm"
      :rules="rules"
      ref="loginForm"
    >
      <!-- 验证码登录 -->
      <template v-if="loginMethod === 'code'">
        <!-- 手机号输入 -->
        <el-form-item prop="phone">
          <el-input v-model="loginForm.phone" placeholder="请输入手机号" />
        </el-form-item>
        <!-- 动态切换验证码/密码 -->
        <el-form-item prop="code" v-if="loginMethod === 'code'">
          <el-row :gutter="10">
            <el-col :span="15">
              <el-input v-model="loginForm.code" placeholder="请输入验证码" />
            </el-col>
            <el-col :span="9">
              <el-button
                class="code-btn"
                :disabled="!canSendCode"
                @click="getVerifyCode"
              >
                {{ codeBtnText }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </template>
      <!-- 密码登录 -->
      <template v-else>
        <!-- 用户名/手机号 -->
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入手机号" />
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
      </template>

      <!-- 同意条款 -->
      <el-form-item prop="agree" style="margin-bottom: 0" class="checkbox">
        <el-checkbox class="agree-text" v-model="loginForm.agree">
          <span class="txt">我已阅读并同意用户协议与隐私政策</span>
        </el-checkbox>
      </el-form-item>

      <!-- 登录按钮 -->
      <el-button type="primary" class="login-btn" @click="handleLogin">
        登录
      </el-button>
    </el-form>

    <!-- 微信登录 -->
    <!--    <div class="wechat-login">-->
    <!--      <div class="divider">或</div>-->
    <!--      <el-button class="wechat-btn">-->
    <!--        <i class="iconfont icon-wechat" />-->
    <!--        使用微信扫码登录-->
    <!--      </el-button>-->
    <!--    </div>-->

    <!-- 申请试用账号 -->
    <div class="flex justify-end application-btn">
      <el-button type="text" @click="handleRegisterApplication">申请试用账号</el-button>
    </div>
  </div>
</template>

<script>
import logoIcon from '@/assets/images/home/logo.svg';
import { sendCodeApi, userLoginApi, userInfoApi, permissionDetailApi } from '@/api/login';

export default {
  name: 'loginComp',
  components: {
    logoIcon,
  },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };

    return {
      loginMethod: 'password', // 登录方式 code | password
      codeBtnText: '发送验证码', // 验证码按钮文字
      countdown: 59, // 倒计时
      isSend: false,  // 是否已经发送
      canSendCode: false, // 能否发送验证码
      timer: null, // 定时器对象
      loginForm: {
        phone: '',
        code: '',
        username: '',
        password: '',
        agree: false,
      },
      loginLoading: false,
      rules: {
        phone: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        username: [{ required: true, message: '请输入手机号', trigger: ['blur', 'change'] }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' },
        ],
        agree: [
          {
            validator: (rule, value, callback) => {
              value ? callback() : callback(new Error('请同意并勾选服务条款'));
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  computed: {
    computedSystemName() {
      return '科技成果转化AI助手';
    },
  },
  methods: {
    // 切换 登录方式
    changeLoginMethod() {
      this.loginForm.phone = '';
      this.loginForm.code = '';
      this.loginForm.username = '';
      this.loginForm.password = '';
      this.$refs.loginForm.resetFields();
    },

    // 获取验证码
    async getVerifyCode() {

      // 防止重复发送
      if (this.isSend) {
        return;
      }

      this.isSend = true;

      try {
        // 调用获取验证码接口
        const res = await sendCodeApi({
          type: 'QuickLogin',
          phone: this.loginForm.phone,
        });

        if (res.code == 200) {
          // 开始倒计时
          this.$message.success('验证码发送成功，请查收');
          this.canSendCode = false;
          this.timer = setInterval(() => {
            this.codeBtnText = `${this.countdown}s后重新发送`;
            if (this.countdown-- <= 0) {
              clearInterval(this.timer);
              this.isSend = false;
              this.canSendCode = true;
              this.codeBtnText = '发送验证码';
              this.countdown = 59;
            }
          }, 1000);
        } else {
          this.isSend = false;
          this.$message.error(res.message);
        }
      } catch (err) {
        this.isSend = false;
        console.log(err);
        // this.$message.error('验证码发送失败，请重试');
      }
    },

    // 处理登录
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true;

          let pa = {
            loginType: this.loginMethod === 'code' ? 'verifyCode' : 'password', // password/verifyCode
            username: this.loginMethod === 'code' ? this.loginForm.phone : this.loginForm.username,
          };

          if (this.loginMethod === 'code') {
            pa['verifyCode'] = this.loginForm.code;
          } else {
            pa['password'] = this.loginForm.password;
          }

          // 调用登录接口
          userLoginApi(pa)
            .then((res) => {
              let token = '';

              if (res.data.token) {
                token = res.data.token;
              } else {
                this.$message.warning(res.data.message);
              }

              // 存储token, 用户信息
              if (token) {
                this.$store.commit('SET_TOKEN', { token: token });
                this.userInfo();
              }
            })
            .finally(() => {
              this.loginLoading = false;
            });
        }
      });
    },

    // 用户信息
    userInfo() {
      userInfoApi().then(res => {
        const { username, userId, nickname, org } = res.data;
        this.$store.commit('SET_UserDetails', {
          userName: username,
          id: userId,
          nickName: nickname,
          org: org,
        });
        // 存储人才详情特定token
        localStorage.setItem(
          'TalentToken',
          '495aae05-f4eb-ff0c-27d6-c3be75cc8926'
        );
        // 获取访问权限
        this.getRolesData(userId);
      })
    },

    // 获取访问权限
    getRolesData(userId) {
      let pa = { userId };
      permissionDetailApi(pa).then((res) => {
        if (res.code === 200) {
          if (res.data.system === 'achievement-assistant') {
            // quota
            let quotaList = res.data.permissionApiQuotaVO.apiQuotaList;
            this.$store.commit('SET_Quota', quotaList);
            // tags
            if (res.data.permissionTagVO.tags && res.data.permissionTagVO.tags?.length) {
              let Tags = res.data.permissionTagVO.tags;
              this.$store.commit('SET_Tags', Tags);
              let userNav = Tags.filter(tag => tag.label !== '文件管理' && tag.authorization == 1);
              // 重定向目标地址
              this.$router.push({ name: userNav[0].name });
              // 登录成功
              this.$message({ message: '登录成功！', duration: 1200, type: 'success' });
            } else {
              this.$message.warning('该账号暂无使用权限，请联系管理员');
              setTimeout(()=>{
                this.$store.commit('logout');
                this.$router.push({ name: 'login' });
              },300)
            }
          } else {
            this.$message.warning('该账号暂无使用权限，请联系管理员');
            setTimeout(()=>{
              this.$store.commit('logout');
              this.$router.push({ name: 'login' });
            },300);
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },

    // 申请试用账号
    handleRegisterApplication() {
      this.$router.push({ name: 'registerApplication' });
    }
  },

  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.timer);
  },

  watch: {
    // 监听手机号，格式正确发送验证码按钮可点击
    'loginForm.phone'(newVal) {
      this.canSendCode = !this.isSend && /^1[3-9]\d{9}$/.test(newVal);
    },
  },
};
</script>

<style scoped lang="less">
.login-container {
  width: 480px;
  height: 450px;
  box-sizing: border-box;
  padding: 30px 0 30px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 50px;
  left: 0;
  margin: auto;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;

  span {
    color: #2f70ff;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 1px;
    margin-left: 30px;
  }
}

.login-type {
  margin-bottom: 30px;
  text-align: center;

  /deep/.el-radio-group {
    .el-radio-button__inner {
      border: none;
      padding: 5px 0;
      border-radius: 0;
      color: #8b8b8b;
      border-bottom: 3px solid transparent;
      font-weight: 600;
      font-size: 15px;

      &:hover {
        //color: #2f70ff;
      }
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #2f70ff;
      background-color: transparent;
      box-shadow: none;
      border-bottom: 3px solid #2f70ff;
    }
  }
}

.region-tip {
  height: 12px;
  color: rgba(153, 153, 153, 0.9);
  font-size: 13px;
  margin-bottom: 10px;
  text-align: center;
}

.login-form {
  width: 350px;
  margin: 0 auto;

  /deep/.el-input__inner {
    border-width: 2px;
    border-radius: 8px;
  }

  /deep/ .el-input.is-active .el-input__inner,
  /deep/ .el-input__inner:focus {
    border-color: #2f70ff;
  }

  .code-btn {
    border-radius: 8px !important;
    border-width: 2px;
    width: 100%;
    text-align: center;
    padding: 11px 10px !important;
  }

  .code-btn:not(.is-disabled):focus,
  .code-btn:not(.is-disabled):hover {
    color: #2f70ff;
    border-color: #2f70ff;
  }

  .checkbox {
    /deep/ .is-checked {
      .el-checkbox__inner {
        background-color: #2f70ff !important;
        border-color: #2f70ff !important;
      }
    }
  }

  .agree-text {
    display: flex;

    /deep/ .el-checkbox__input {
      margin-top: 2px;
      margin-left: 2px;
    }

    .txt {
      white-space: pre-wrap;
      font-size: 13px;
      color: #404040;
    }
  }
}

.login-btn {
  width: 100%;
  background: #2c7cff;
  margin-top: 20px;
  border-radius: 8px;
}

.wechat-login {
  margin-top: 30px;
  text-align: center;
}

.application-btn {
  margin: 30px 65px 0;
  /deep/ .el-button {
    span {
      color: #2c7cff;
      &:hover {
        text-decoration: underline;
      }
    }
    padding: 0 !important;
  }
}

.divider {
  color: #ccc;
  margin: 20px 0;
  position: relative;
}

.divider:before,
.divider:after {
  content: '';
  border-top: 1px solid #eee;
  width: 45%;
  position: absolute;
  top: 50%;
}

.divider:before {
  left: 0;
}
.divider:after {
  right: 0;
}

.wechat-btn {
  color: #2c7cff;
  border-color: #2c7cff;
}

.icon-wechat {
  margin-right: 8px;
  font-size: 18px;
}
</style>
